import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import type { ApiResponse } from './api-state.service';
import type { ApiStateClient } from './api-state-client.token';

@Injectable({ providedIn: 'root' })
export class ApiStateMockService implements ApiStateClient {
  getStatus(): Observable<ApiResponse> {
    return of({
      status: 'ok',
      message: 'Mock API is running',
      timestamp: new Date().toISOString(),
    } satisfies ApiResponse).pipe(delay(300));
  }
}
